// --------------------------------------------------------
// COMPANY LIST - CompanyList
// --------------------------------------------------------

// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------
import React, { useCallback, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import SearchIcon from '@mui/icons-material/Search';
import LabelInput from '../../components/labelInput/LabelInput';
import ContainerWithSidebar from '../../components/UI/containerWithSidebar/ContainerWithSidebar';
import { Text } from '../../components/UI/generalLayout/Layout.styled';
import CompanyListItem from '../../components/companyListItem/CompanyListItem';
import { CompanyListItemContainer } from './CompanyList.styled';
import { Paths } from '../../enums/Paths';
import * as companyActions from '../../store/actions/company';
import * as loginActions from '../../store/actions/login';
import { useAppDispatch } from '../..';
import { useSelector } from 'react-redux';
import Company from '../../models/core/company/Company';
import ItemList from '../../components/itemList/ItemList';
import Colors from '../../constants/Colors';
import ScreenHeader from '../../components/UI/screenHeader/ScreenHeader';
import { MainContainer } from '../fileImport/FileImport.styled';

// --------------------------------------------------------
// COMPANY LIST INTERFACE
// --------------------------------------------------------

/**
 * A component that renders a Screen.
 *
 * @param props Properties
 * @param props.route The route
 * @param props.navigation The navigator
 * @returns The component JSX.
 */
function CompanyList(): JSX.Element {
    // --------------------------------------------------------
    // COMPANY LIST PRIVATE DECLARATIONS
    // --------------------------------------------------------
    const [companyListHeaderFields] = useState([{name: 'Nome', width: '45%', align: null}, {name: 'CNPJ', width: '25%', align: null}, {name: 'Ativar/Desativar', width: '30%', align: 'right'}])

    const companyList: Company[] = useSelector((state: any)=>state.company.companies)

    const [searchCompanyQuery, setSearchCompanyQuery] = useState('')

    const navigate = useNavigate()
    const dispatch = useAppDispatch();

    const fetchCompanies = useCallback(async ()=>{
        await dispatch(companyActions.fetchCompanyList())
    }, [dispatch])

    const filterCompanies = useCallback(async ()=>{
        if(searchCompanyQuery.length >= 3 || searchCompanyQuery === ''){
            await dispatch(companyActions.filterCompanyList(searchCompanyQuery))
        }
    }, [searchCompanyQuery])
    
    useEffect(()=>{
        fetchCompanies()
    }, [])

    useEffect(() => {
        filterCompanies()
    }, [searchCompanyQuery, filterCompanies])

    const navigateToRegisterCompany = () => {
        return navigate(Paths.RegisterCompany)
    }

    const navigateToEditCompany = (company: Company)=>{
        return navigate(Paths.RegisterCompany, { state: { companyState: company } })
    }

    const navigateToCompanyDetail = (company: Company)=>{
        return navigate(Paths.RegisterCompany, { state: { companyState: company, isView: true } })
    }

    const activateOrInactivateCompany = async (id: string, isActive: boolean)=>{
        await dispatch(companyActions.activateOrDeactivateCompany(id, isActive))
        fetchCompanies();
        await dispatch(loginActions.updateUserInfo());
    }

    return <ContainerWithSidebar>
            <ScreenHeader 
                screenTitle={'Empresas cadastradas'} 
                rightButtonText={'Cadastrar nova empresa'} 
                onRightButtonClick={navigateToRegisterCompany} 
            />
            <LabelInput
                value={searchCompanyQuery}
                placeholder="Busca de empresa"
                onChangeText={(event: any) => { setSearchCompanyQuery(event.target.value) }}
                rightIcon={<SearchIcon />}
            />
            {searchCompanyQuery.length > 0 && (<div style={{ paddingLeft: 12, paddingRight: 12 }}><Text color={Colors.lightBlue}>Resultados para: {searchCompanyQuery} </Text></div>)}
            <ItemList list={companyList} listHeader={companyListHeaderFields}>
                <CompanyListItemContainer>
                    {companyList.map(company => {
                        return (
                        <React.Fragment key={company.id}>
                            <CompanyListItem 
                                isCompany
                                name={company.nomeFantasia}
                                id={company.id}
                                cnpj={company.cnpj}
                                isActiveRegister={!company.inativo}
                                onEdit={() => { navigateToEditCompany(company) } }
                                onView={() => { navigateToCompanyDetail(company) } }
                                onOrpenConfig={() => {}}
                                onActivateInactivate={activateOrInactivateCompany}  />
                        </React.Fragment>
                        )
                    })}
                </CompanyListItemContainer>
            </ItemList>

        </ContainerWithSidebar>;
}

export default CompanyList;
